import { useCallback } from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { WrapStatus } from "../../../types/wrapQuote";

export const SwapAgainButton = () => {
  const handleOnClick = useCallback(() => {
    GlobalStore.update(s => {
      s.wrapQuote = undefined;
      s.wrapStatus = WrapStatus.ENTRY;
    });
  }, []);

  return (
    <button
      type="button"
      className={`btn btn-bebop-primary btn-lg btn-block text-white button-font-size`}
      onClick={handleOnClick}
    >
      Wrap Again
    </button>
  );
};
